// extracted by mini-css-extract-plugin
export default {"unityWrapperBG":"UnityComponent_unityWrapperBG__raYX7","pendingBtn":"UnityComponent_pendingBtn__SPjMa"};